import React, {FC, memo, MouseEventHandler} from 'react'
import {KTSVG} from '../../../../helpers'
import {SortOrder} from '../types'

type PropsSortButton = {
    sortOrder: SortOrder;
    columnKey: string;
    sortKey: string;
    onClick: MouseEventHandler<HTMLButtonElement>;
    label: string;
}

const SortButton: FC<PropsSortButton> = memo(({
                                                  sortOrder,
                                                  columnKey,
                                                  sortKey,
                                                  onClick,
                                                  label,
                                              }) => {

    const isActive = sortKey === columnKey;
    const iconPath = isActive ? (sortOrder === 'desc' ? 'arr072' : 'arr073') : '';


    return (
        <>
            <button
                className={`btn btn-sm btn-icon w-auto px-0 btn-active-color-primary ${label === 'Semaine' ? 'ms-3' : ''}`}
                onClick={onClick}
            >
                <span className="text-gray-500">{label}</span>
                {isActive && (
                    <KTSVG
                        path={`/media/icons/duotune/arrows/${iconPath}.svg`}
                        className="svg-icon-3 svg-icon-primary mx-1"
                    />
                )}
            </button>
        </>
    )
})

export {SortButton}